const SIDEBAR_DEVICE_DETAIL_KEY = "sidebar::device::view";
const SIDEBAR_EDIT_CONTENT_KEY = "sidebar::content-editor::detail";

export { SIDEBAR_DEVICE_DETAIL_KEY, SIDEBAR_EDIT_CONTENT_KEY };
